export const RADON_TEST_STATUS = {
  COMPLETED: 1,
  NOT_COMPLETED: 2,
  UNKNOWN: 3,
};

export const DEFAULT_ROOMS = [
  {
    name: 'Kjøkken',
    comments: '',
    pictures: [],
  },
  {
    name: 'Soverom',
    comments: '',
    pictures: [],
  },
  {
    name: 'Bad',
    comments: '',
    pictures: [],
  },
  {
    name: 'Stue',
    comments: '',
    pictures: [],
  },
];

export function getDefaultFlatStructure(reportType = 'takeover') {
  const baseStructure = {
    step: 0,
    reportType: reportType,
    status: 'draft',
    latest_step: 0,
  };

  if (reportType === 'moveout') {
    return {
      ...baseStructure,
      landlord_given_name: '',
      landlord_family_name: '',
      landlord_email: '',
      tenant_given_name: '',
      tenant_family_name: '',
      tenant_email: '',
      inspection_participants_landlord_present: undefined,
      inspection_participants_tenant_present: undefined,
      inspection_participants_landlord_representative: '',
      inspection_participants_tenant_representative: '',
      payment_status_all_paid: undefined,
      payment_status_outstanding_amount: '',
      payment_status_outstanding_details: '',
      deviation_summary_settlement_method: '',
      deviation_summary_total_amount: 0,
      keys_returned_entrance: '0',
      keys_returned_entrance_not_relevant: false,
      keys_returned_mailbox: '0',
      keys_returned_mailbox_not_relevant: false,
      keys_returned_electricity: '0',
      keys_returned_electricity_not_relevant: false,
      keys_returned_additional_keys: [],
      keys_returned_total_count: '0',
      electricity_meter_reading_moveout: '',
      electricity_meter_date_moveout: '',
      electricity_meter_not_relevant: false,
      rental_object_electricity_meter_number: '',
      water_meter_reading_moveout: '',
      water_meter_date_moveout: '',
      water_meter_not_relevant: false,
      tenancy_water_meter_number: '',
      utility_settlement_electricity_completed: false,
      utility_settlement_water_completed: false,
      utility_settlement_costs_paid: undefined,
      utility_settlement_remaining_amount: '',
      utility_settlement_payment_method: '',
      property_inspection_approved: undefined,
      property_inspection_comments: [],
      deposit_not_relevant: undefined,
      deposit_payout_tenant_account: '',
      deposit_payout_tenant_amount: '',
      deposit_payout_landlord_account: '',
      deposit_payout_landlord_amount: '',
      guarantee_release_required: false,
      guarantee_release_provider: '',
      signature_place: '',
      signature_date: '',
      landlord_signature_image: undefined,
      tenant_signature_image: undefined,
      deviations: [],
    };
  }

  return {
    ...baseStructure,
    landlord_given_name: '',
    landlord_family_name: '',
    landlord_email: '',
    landlord_cell_phone: '',
    landlord_representative: '',
    landlord_is_represented: '',
    landlord_bank_account: '',
    tenant_given_name: '',
    tenant_family_name: '',
    tenant_email: '',
    tenant_cell_phone: '',
    tenant_representative: '',
    tenant_is_represented: '',
    rental_object_street: '',
    rental_object_postal_zipcode: '',
    rental_object_postal_area: '',
    rental_object_apartment_number: '',
    rental_object_type: '',
    rental_object_room_number: '',
    rental_object_appliance_included: false,
    rental_object_appliance_kjoleskap: 'off',
    rental_object_appliance_komfyr: 'off',
    rental_object_appliance_oppvaskmaskin: 'off',
    rental_object_appliance_vaskemaskin: 'off',
    rental_object_appliance_torketrommel: 'off',
    rental_object_electricity_meter_reading: '',
    rental_object_electricity_meter_date: '',
    rental_object_electricity_meter_id: '',
    rental_object_electricity_meter_number: '',
    rooms: DEFAULT_ROOMS,
    tenancy_due_date: '',
    tenancy_due_period: '',
    tenancy_unlimited: false,
    tenancy_rent: '',
    tenancy_start_date: '',
    tenancy_end_date: '',
    tenancy_deposit: 'no_deposit',
    tenancy_first_rent_paid: undefined,
    tenancy_electricity_included: 0,
    tenancy_water_included: 0,
    tenancy_water_meter_number: '',
    tenancy_water_meter_reading: '',
    checklist_locks_checked: 0,
    checklist_locks_comments: '',
    checklist_heating_checked: 0,
    checklist_heating_sources_count: 0,
    checklist_heating_comments: '',
    checklist_switches_checked: 0,
    checklist_switches_comments: '',
    checklist_appliances_checked: 0,
    checklist_appliances_comments: '',
    checklist_lights_checked: 0,
    checklist_lights_comments: '',
    checklist_water_checked: 0,
    checklist_water_comments: '',
    checklist_post_doorbell_checked: 0,
    checklist_post_doorbell_comments: '',
    checklist_fire_safety_checked: 0,
    checklist_fire_safety_comments: '',
    checklist_electrical_panel_checked: 0,
    checklist_electrical_panel_comments: '',
    rental_object_radon_test_completed: RADON_TEST_STATUS.UNKNOWN,
    checklist_comments: '',
    keys_entrance: '0',
    keys_post: '0',
    keys_electricity: '0',
    keys_system_number: '',
    keys_electronic_lock: 0,
    keys_additional_keys: [],
    signature_place: '',
    signature_date: '',
    landlord_signature_image: undefined,
    tenant_signature_image: undefined,
    electricity_husleie_strom_opted_in: null,
    insurance_husleie_innbo_opted_in: null,
  };
}
